export default "__VITE_ASSET__bLhq_7Kk__"